import { Product } from "interfaces";
import { Skeleton } from "@mui/material";
import ProductCard from "components/productCard/productCard";
import ListHeader from "components/listHeader/listHeader";
import cls from "./productList.module.scss";

type Props = {
  title?: string;
  products: Product[];
  loading?: boolean;
  uuid?: string;
};

export default function ProductList({
  title,
  products,
  loading = false,
  uuid = "popular",
}: Props) {
  return (
    <section
      data-section
      id={uuid}
      style={{
        display: !loading && products.length === 0 ? "none" : "block",
      }}
    >
      <div className={cls.container}>
        <div className={cls.header}>
          <ListHeader title={title} />
        </div>
        <div className={cls.list}>
          {!loading
            ? products.map((item) => <ProductCard key={item.id} data={item} />)
            : Array.from(new Array(4)).map((_, index) => (
                <Skeleton
                  variant="rectangular"
                  key={index}
                  className={cls.shimmer}
                />
              ))}
        </div>
      </div>
    </section>
  );
}
